import React, { useState, useEffect } from "react";
import {
  Tag,
  message,
  Button,
  Form,
  Input,
  Table,
  Space,
  Modal,
  Select,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import DepartmentApi from "@api/department";
import InspectionApi from "@api/inspectionnew";
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};
const DepartMent = () => {
  const [form] = Form.useForm();
  const [editId, setEditId] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelModify, setModelModify] = useState("add");
  const [personModal, setPersonModal] = useState(false);
  const [deptPersonLoading, setDeptPersonLoading] = useState(false);
  const [personList, setPersonList] = useState([]);
  const [addPersonModal, setAddPersonModal] = useState(false);
  const [person, setPerson] = useState();
  const [lookPersonId, setLookPersonId] = useState();
  const [deptChildList, setDeptChildList] = useState([]);
  const [pid, setPid] = useState();

  useEffect(() => {
    list();
  }, []);

  const showModel = (type, params) => {
    if (type === "edit" && params) {
      setEditId(params.id);
      form.setFieldsValue({ name: params.deptName });
    }
    setModelModify(type);
    setIsModalOpen(true);
  };

  const lookPerson = (id) => {
    setLookPersonId(id);
    getPersonList(id);
  };

  const getPersonList = (id) => {
    setDeptPersonLoading(true);
    setPersonModal(true);
    DepartmentApi.getDeptHeadersByDeptId({ deptId: id }).then((res) => {
      if (res.status !== "0") return;
      setDeptPersonLoading(false);
      setPersonList(res.data);
    });
  };

  const addDeptPerson = () => {
    if (!person) return message.error("班组负责人不能为空");
    DepartmentApi.addDeptHeader({ deptId: lookPersonId, userId: person }).then(
      (res) => {
        if (res.status !== "0") return;
        message.success("新增成功");
        setPerson("");
        setAddPersonModal(false);
        getPersonList(lookPersonId);
      }
    );
  };

  const delPerson = (deptId, userId) => {
    DepartmentApi.delDeptHeader({ deptId, userId }).then((res) => {
      if (res.status !== "0") return;
      message.success("删除成功");
      getPersonList(lookPersonId);
    });
  };

  const getDeptChildPerson = () => {
    setAddPersonModal(true);
    DepartmentApi.getUsersByDeptId({
      deptId: lookPersonId,
      containDeptHeaders: 0,
    }).then((res) => {
      if (res.status !== "0") return;
      setDeptChildList(res.data);
    });
  };

  // 处理新增或编辑的数据
  const submiteForm = () => {
    form.validateFields().then(async (values) => {
      const params = {
        ...values,
        type: 2,
        pid,
      };
      if (modelModify === "add") {
        setConfirmLoading(true);
        const res = await DepartmentApi.create(params);
        setConfirmLoading(false);
        if (res.status !== "0") return;
        list();
        form.resetFields();
        setIsModalOpen(false);
        message.success("创建成功");
      } else {
        params.id = editId;
        setConfirmLoading(true);
        const res = await DepartmentApi.update(params);
        setConfirmLoading(false);
        if (res.status !== "0") return;
        list();
        form.resetFields();
        setIsModalOpen(false);
        message.success("修改成功");
      }
    });
  };

  // 删除班组
  const delMenu = (id) => {
    Modal.confirm({
      title: "删除班组",
      icon: <ExclamationCircleOutlined />,
      content: "此操作将永久删除班组, 是否继续?",
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        const res = await DepartmentApi.delete({ id });
        if (res.status !== "0") return;
        message.success("删除成功");
        list();
      },
    });
  };

  const list = () => {
    setLoading(true);
    InspectionApi.patrolDeptGetPatrolDepts().then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { patrolDepts, patrolParentDeptId } = res.data;
      setDataSource(patrolDepts);
      setPid(patrolParentDeptId);
    });
  };

  const resetForm = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "班组名称",
      dataIndex: "deptName",
      key: "deptName",
      align: "center",
    },
    {
      title: "操作",
      key: "action",
      align: "center",
      render: (record) => {
        return (
          <Space size="middle">
            <Tag onClick={() => showModel("edit", record)} color="#2db7f5">
              编辑
            </Tag>
            <Tag onClick={() => lookPerson(record.id)} color="#2db7f5">
              班组负责人
            </Tag>
            <Tag onClick={() => delMenu(record.id)} color="#f50">
              删除
            </Tag>
          </Space>
        );
      },
    },
  ];

  const deptPersonColumns = [
    {
      title: "负责人姓名",
      dataIndex: "realName",
      width: 300,
      key: "realName",
    },
    {
      title: "账户",
      width: 250,
      dataIndex: "name",
      key: "name",
    },
    {
      title: "操作",
      key: "action",
      width: 300,
      fixed: "right",
      align: "center",
      render: (record) => {
        return (
          <Space size="middle">
            <Tag
              onClick={() => delPerson(record.deptId, record.id)}
              color="#f50"
            >
              删除
            </Tag>
          </Space>
        );
      },
    },
  ];

  return (
    <div className="menu-container">
      <Button type="primary" onClick={() => showModel("add")}>
        新增
      </Button>
      <div className="menu-table">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={dataSource}
          pagination={false}
          loading={loading}
        />
      </div>
      {/* 新增弹出层 */}
      {isModalOpen && (
        <Modal
          title={modelModify == "add" ? "添加班组" : "编辑班组"}
          open={isModalOpen}
          onOk={submiteForm}
          onCancel={resetForm}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              name="name"
              label="班组名称"
              rules={[
                {
                  required: true,
                  message: "请输入班组名称",
                },
              ]}
            >
              <Input placeholder="请输入班组名称" />
            </Form.Item>
          </Form>
        </Modal>
      )}
      {/* /新增弹出层 */}
      {/* 班组负责人弹窗 */}
      <Modal
        title="班组负责人管理"
        open={personModal}
        width={800}
        onOk={() => setPersonModal(false)}
        onCancel={() => setPersonModal(false)}
      >
        <div className="deptPerson-container">
          <div className="deptPerson-title">
            <Button
              onClick={() => getDeptChildPerson()}
              type="primary"
              size="mini"
            >
              新增
            </Button>
          </div>
          <div className="deptPerson-bd">
            <Table
              columns={deptPersonColumns}
              rowKey={(record) => record.id}
              dataSource={personList}
              pagination={false}
              loading={deptPersonLoading}
            />
          </div>
        </div>
      </Modal>
      {/* /班组负责人弹窗 */}
      <Modal
        title="新增班组负责人"
        open={addPersonModal}
        onCancel={() => (setAddPersonModal(false), setPerson(""))}
        onOk={() => addDeptPerson()}
      >
        <Select
          style={{
            width: 300,
          }}
          placeholder="请选择班组负责人"
          onChange={(e) => setPerson(e)}
          value={person}
        >
          {deptChildList.map((item) => {
            return (
              <Select.Option value={item.id} key={item.id}>
                {item.realName}
              </Select.Option>
            );
          })}
        </Select>
      </Modal>
    </div>
  );
};

export default DepartMent;
